/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { BudgetEffects } from './budget.effect';
import { OrgUnitEffects } from './org-unit.effect';
import { PermissionEffects } from './permission.effect';
import { CostCenterEffects } from './cost-center.effect';
import { B2BUserEffects } from './b2b-user.effect';
import { UserGroupEffects } from './user-group.effect';

export const effects: any[] = [
  BudgetEffects,
  OrgUnitEffects,
  UserGroupEffects,
  PermissionEffects,
  CostCenterEffects,
  B2BUserEffects,
];

export * from './budget.effect';
export * from './org-unit.effect';
export * from './user-group.effect';
export * from './permission.effect';
export * from './cost-center.effect';
export * from './b2b-user.effect';
